// userReducer.js
import * as actionTypes from './actions';

const initialState = {
  user: undefined
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.user
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
};

export default userReducer;
